<template>
  <div>
    <hr class="block-separator" :class="classes" />
    <!-- <div class="debug text-xs">{{ block }}</div> -->
  </div>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const classes = [
  props.block?.data?.align === 'center' ? 'max-w-3xl' : 'w-full',
  // props.block?.depth === 0 ? 'is-root' : 'is-child',
].filter(str => str).join(' ')
</script>

<style lang="scss" scoped>
.block-separator {
  @apply h-px;
  @apply border-0 relative my-8;

  &:after {
    content: '';
    @apply block w-full h-px bg-gray-200;
  }

  &.is-full {
    // 
  }

  &.is-center {
    // @apply col-prose;
  }
  
  &.is-root {
    // @apply my-0;
  }
  
  &.is-child {
    // 
  }

  &.is-first {
    // @apply mt-0;
  }

  &.is-last {
    // @apply mb-0;
  }
}
</style>
